import { ErrorHandler, inject, Injectable, Provider } from '@angular/core';

import { SentryErrorHandler } from '@sentry/angular';

@Injectable({
  providedIn: 'root'
})
export class CustomErrorHandler implements ErrorHandler {
  readonly #sentryErrorHandler = inject(SentryErrorHandler);

  handleError(error: Error): void {
    this.#sentryErrorHandler.handleError(error);
  }
}

export const errorHandlerProvider: Provider = {
  provide: ErrorHandler,
  useClass: CustomErrorHandler
};
